import { Link } from 'react-router'

import { POWERED_BY_LABEL, platformWordmarkUrl, showPoweredBy, useBrandStore } from '@/brand'
import { env } from '@/config/env'
import { cn } from '@/design'
import { BrandLogo } from './brand-logo'
import { BrandMark } from './brand-mark'
import { NavList } from './nav-list'

/**
 * Desktop sidebar (≥1024 px, 248 px) and tablet rail (768–1023 px, 64 px). Navy gradient from the
 * tenant's primary colour — the prototype's `.sidebar`.
 */
export function Sidebar({ compact }: { readonly compact: boolean }) {
  const brand = useBrandStore((state) => state.brand)
  const poweredBy = showPoweredBy(brand)
  const wordmark = platformWordmarkUrl(brand) !== null
  return (
    <aside
      className={cn(
        'sticky top-0 hidden h-screen shrink-0 flex-col bg-[linear-gradient(180deg,var(--brand-primary-deep)_0%,color-mix(in_srgb,var(--brand-primary-deep)_80%,black)_100%)] text-[#E7ECF6] md:flex',
        compact ? 'w-[var(--rail-w)] px-2 py-4' : 'w-[var(--sidebar-w)] px-4 py-5',
      )}
    >
      <Link
        to="/"
        className={cn(
          'mb-4 flex items-center gap-2.5 border-b border-white/10 pb-4',
          compact ? 'justify-center px-0' : 'px-1',
        )}
        aria-label={`${brand.product_name} home`}
      >
        {compact ? (
          <BrandMark size="sm" onDark={wordmark} />
        ) : wordmark ? (
          <BrandLogo size="md" onDark />
        ) : (
          <BrandMark size="md" />
        )}
        {!compact && !wordmark && (
          <span className="min-w-0">
            <span className="block truncate font-display text-[17px] font-semibold text-white">
              {brand.product_name}
            </span>
            <span className="block text-[10.5px] tracking-[0.05em] text-[#9FB0CC] uppercase">
              Revenue recovery
            </span>
          </span>
        )}
      </Link>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <NavList compact={compact} />
      </div>
      <div
        className={cn(
          'mt-4 border-t border-white/10 pt-3 text-[10.5px] text-[#9FB0CC]',
          compact && 'text-center',
        )}
      >
        {!compact && poweredBy && <div>{POWERED_BY_LABEL}</div>}
        <div className="font-mono" title="Build">
          {compact ? env.buildSha.slice(0, 7) : `build ${env.buildSha.slice(0, 7)}`}
        </div>
      </div>
    </aside>
  )
}
